<template>
  <div class="register-page">
    <!-- 顶部区域 -->
    <div class="page-header">
      <div class="header-back" @click="goBack">
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
      <div class="header-decoration">
        <div class="deco-circle deco-circle-1"></div>
        <div class="deco-circle deco-circle-2"></div>
      </div>
      <div class="header-content">
        <h1 class="page-title">{{ EDIT_IF ? '编辑资料' : '用户注册' }}</h1>
        <p class="page-subtitle">{{ EDIT_IF ? '完善您的个人信息' : '加入Acuvue iLearn' }}</p>
      </div>
    </div>

    <!-- 表单卡片 -->
    <div class="form-card">
      <van-form @submit="onSubmit">
        <!-- 基本信息 -->
        <div class="form-section">
          <div class="section-title">
            <span class="title-icon">👤</span>
            <span>基本信息</span>
          </div>

          <div class="field-group">
            <van-field
              readonly
              clickable
              required
              name="Identity"
              :value="Identity"
              label="机构类型"
              placeholder="请选择所属机构类型"
              right-icon="arrow-down"
              @click="showPicker_Identity = true"
            />
            <van-popup v-model="showPicker_Identity" position="bottom" round get-container="body">
              <van-picker
                show-toolbar
                title="选择机构类型"
                :columns="['医院', '视光中心', '零售商', '经销商', '服务商', 'JJVC', '高校', '其他']"
                @confirm="onConfirm_Identity"
                @cancel="showPicker_Identity = false"
              />
            </van-popup>

            <van-field
              v-model="username"
              name="name"
              required
              label="姓名"
              clearable
              placeholder="请输入您的姓名"
              maxlength="11"
            />
            <van-field
              v-model="userphone"
              name="phone"
              required
              label="手机号"
              clearable
              :disabled="EDIT_IF"
              placeholder="请输入您的手机号"
              maxlength="11"
            />

            <van-field
              v-if="!EDIT_IF"
              v-model="password"
              type="digit"
              name="CheckCode"
              required
              label="验证码"
              placeholder="请输入短信验证码"
              maxlength="6"
              clearable
            >
              <template #button>
                <van-button
                  class="code-btn"
                  :class="{ 'code-btn-disabled': SEND_CODE_IF }"
                  plain
                  size="small"
                  @click="sendCode"
                  :disabled="SEND_CODE_IF"
                  native-type="button"
                >
                  {{ codeMsg }}
                </van-button>
              </template>
            </van-field>

            <van-field v-model="useremail" name="email" label="邮箱" clearable placeholder="请输入您的邮箱（选填）" maxlength="100" />
            <van-field v-model="userprofessiona" name="professiona" label="职称" clearable placeholder="请输入您的职称（选填）" maxlength="30" />
            <van-field
              v-if="Identity !== '零售商'"
              v-model="EnterpriseName"
              name="EnterpriseName"
              :required="isEnterpriseNameRequired"
              label="单位名称"
              clearable
              placeholder="请输入医院/企业/学校名称"
            />

            <!-- 零售商门店信息 -->
            <template v-if="Identity === '零售商'">
              <van-field
                readonly
                clickable
                required
                label="所在城市"
                :value="pca_text"
                placeholder="请选择您所在的城市"
                right-icon="arrow-down"
                @click="showPopup(0)"
              />
              <van-field
                readonly
                clickable
                required
                label="零售商"
                :value="account_text"
                placeholder="请选择零售商"
                right-icon="arrow-down"
                @click="showlss(0)"
              />
              <van-field
                readonly
                clickable
                required
                label="门店"
                :value="store_text"
                placeholder="请选择门店"
                right-icon="arrow-down"
                @click="showmd(0)"
              />
            </template>

            <van-field
              readonly
              clickable
              required
              name="position_pro"
              label="工作职责"
              :value="show_duty"
              placeholder="请选择您的工作职责"
              right-icon="arrow-down"
              @click="showPicker_duty = true"
            />
          </div>
        </div>

        <!-- 从业信息 -->
        <div class="form-section">
          <div class="section-title">
            <span class="title-icon">💼</span>
            <span>从业信息</span>
          </div>

          <div class="field-group">
            <van-field
              readonly
              clickable
              name="vision_exp"
              label="从业时间"
              :value="show_time"
              placeholder="请选择从业时间"
              right-icon="arrow-down"
              @click="showPicker_time = true"
            />

            <div class="checkbox-field">
              <label class="checkbox-label">行业证书</label>
              <van-checkbox-group v-model="ckbox_cfe" class="checkbox-group">
                <van-checkbox
                  v-for="cert in certOptions"
                  :key="cert"
                  :name="cert"
                  shape="square"
                  checked-color="#00b7ee"
                >
                  {{ cert }}
                </van-checkbox>
              </van-checkbox-group>
            </div>
          </div>
        </div>

        <!-- 教育信息 -->
        <div class="form-section">
          <div class="section-title">
            <span class="title-icon">🎓</span>
            <span>教育信息</span>
          </div>

          <div class="field-group">
            <van-field
              readonly
              clickable
              required
              name="edu_qual"
              label="学历"
              :value="show_record"
              placeholder="请选择学历"
              right-icon="arrow-down"
              @click="showPicker_record = true"
            />
            <van-field
              readonly
              clickable
              required
              name="Major"
              label="专业"
              :value="show_subject"
              placeholder="请选择专业"
              right-icon="arrow-down"
              @click="showPicker_subject = true"
            />
            <van-field
              readonly
              clickable
              required
              name="graduation_year"
              label="毕业年份"
              :value="show_year"
              placeholder="请选择毕业年份"
              right-icon="arrow-down"
              @click="showPicker_year = true"
            />
            <van-field v-model="ins_gra" name="ins_gra" required label="毕业院校" placeholder="请输入毕业院校" clearable />
          </div>
        </div>

        <!-- 提交按钮 -->
        <div class="submit-section">
          <van-button class="submit-btn" round block type="info" native-type="submit" :loading="submitting" :disabled="submitting">
            {{ EDIT_IF ? '保存修改' : '立即注册' }}
          </van-button>
        </div>
      </van-form>
    </div>

    <!-- 弹出选择器 - 使用 get-container="body" 确保弹窗定位正确 -->
    <van-popup v-model="show_city" position="bottom" round get-container="body">
      <van-picker show-toolbar title="选择城市" :columns="area_list" @confirm="onConfirm_addr" @cancel="show_city = false" />
    </van-popup>
    <van-popup v-model="show_account" position="bottom" round get-container="body">
      <van-picker show-toolbar title="选择零售商" :columns="account_list" value-key="Account_Short_Name__c" @confirm="onConfirm_account" @cancel="show_account = false" />
    </van-popup>
    <van-popup v-model="show_store" position="bottom" round get-container="body">
      <van-picker show-toolbar title="选择门店" :columns="store_list" value-key="Title" @confirm="onConfirm_store" @cancel="show_store = false" />
    </van-popup>
    <van-popup v-model="showPicker_duty" position="bottom" round get-container="body">
      <van-picker show-toolbar title="工作职责" :columns="columns_duty" @confirm="onConfirm_duty" @cancel="showPicker_duty = false" />
    </van-popup>
    <van-popup v-model="showPicker_time" position="bottom" round get-container="body">
      <van-picker show-toolbar title="从业时间" :columns="columns_time" @confirm="onConfirm_time" @cancel="showPicker_time = false" />
    </van-popup>
    <van-popup v-model="showPicker_record" position="bottom" round get-container="body">
      <van-picker show-toolbar title="学历" :columns="['大专', '理学本科', '医学本科', '研究生', '博士', '其他']" @confirm="onConfirm_record" @cancel="showPicker_record = false" />
    </van-popup>
    <van-popup v-model="showPicker_subject" position="bottom" round get-container="body">
      <van-picker show-toolbar title="专业" :columns="['视光', '医学', '其他']" @confirm="onConfirm_subject" @cancel="showPicker_subject = false" />
    </van-popup>
    <van-popup v-model="showPicker_year" position="bottom" round get-container="body">
      <van-picker show-toolbar title="毕业年份" :columns="columns_year" @confirm="onConfirm_year" @cancel="showPicker_year = false" />
    </van-popup>
  </div>
</template>

<script>
import {
  Member_send_message,
  Member_AddMember,
  Member_QueryMember,
  WeChatMember_UptMember,
  WeChatMember_GetStoreArea,
  WeChatMember_GetStoreAccount,
  WeChatMember_GetStore
} from '../api/api'

export default {
  name: 'register',
  data () {
    return {
      // 表单数据
      QueryMember: {},
      EDIT_IF: false,
      username: '',
      userphone: '',
      useremail: '',
      userprofessiona: '',
      Identity: '',
      EnterpriseName: '',
      ins_gra: '',
      password: '',

      // 提交锁
      submitting: false,

      // 验证码
      SEND_CODE_IF: false,
      codeMsg: '获取验证码',

      // 选择器显示状态
      showPicker_Identity: false,
      showPicker_duty: false,
      showPicker_time: false,
      showPicker_record: false,
      showPicker_subject: false,
      showPicker_year: false,
      show_city: false,
      show_account: false,
      show_store: false,

      // 选中值显示
      show_duty: '',
      show_time: '',
      show_record: '',
      show_subject: '',
      show_year: '',
      pca_text: '',
      account_text: '',
      store_text: '',

      // 选择器数据
      pca_list: [],
      area_list: [],
      account_list: [],
      store_list: [],
      store_object: {},
      ckbox_cfe: [],

      // 选项配置
      columns_time: ['1年', '2年', '3年', '4年', '5年', '6年', '7年', '8年', '9年', '10年及以上'],
      columns_year: [],
      columns_duty: ['医师', '专职验光师', '安视优眼保健顾问 (AC)', '店长或店主任', '总部管理人员', '专业培训师', '配镜顾问', '销售顾问 (店员)', '安视优销售', '教师', '学生', '员工', '助理', '护士'],
      certOptions: ['初级视光师', '中级视光师', '高级技师（验光）', '二级技师（验光）', '高级验光员', '中级验光员', '初级验光员', '无/其他'],

      // 验证规则
      userTel: [
        { required: true, message: '请输入手机号', trigger: 'onBlur' },
        { validator: (value) => /^1[23456789]\d{9}$/.test(value), message: '请输入正确格式的手机号' }
      ]
    }
  },
  async mounted () {
    // 生成年份选项
    for (let i = 2040; i > 1950; i--) {
      this.columns_year.push(i)
    }
    this.columns_year.unshift('未毕业')

    // 编辑模式加载用户数据
    if (this.$route.query.type === 'edit') {
      this.EDIT_IF = true
      const { data } = await Member_QueryMember()
      this.loadUserData(data.response)
    } else if (this.$route.query.registration_source) {
      localStorage.setItem('registration_source', this.$route.query.registration_source)
      this.$router.push({ path: '/policy?link=register' })
    } else {
      // 注册模式：检查是否已同意条款
      const policyAgreed = localStorage.getItem('policyAgreed')
      if (policyAgreed !== 'true') {
        this.$router.push({ path: '/policy?link=register' })
        return
      }
    }

    this.WeChatMember_GetStoreArea_fn()
  },
  computed: {
    // 判断"医院/企业/学校名称"是否必填
    // 医院、视光中心、经销商、服务商、高校、其他 需要必填
    // 零售商、JJVC 不需要必填
    isEnterpriseNameRequired () {
      const requiredTypes = ['医院', '视光中心', '经销商', '服务商', '高校', '其他']
      return requiredTypes.includes(this.Identity)
    }
  },
  methods: {
    loadUserData (response) {
      this.QueryMember = response
      this.username = response.name
      this.useremail = response.email
      this.EnterpriseName = response.EnterpriseName
      this.Identity = response.Identity
      this.ins_gra = response.ins_gra
      this.userphone = response.phone
      this.userprofessiona = response.professiona
      this.show_duty = response.position_pro
      this.show_time = response.vision_exp
      this.show_subject = response.Major
      this.show_year = response.graduation_year
      this.show_record = response.edu_qual
      this.pca_list = [response.Province, response.City, response.Area]
      this.pca_text = this.pca_list.filter(Boolean).join(',')
      this.account_text = response.Account_Short_Name__c
      this.store_object.Outletnumber__c = response.Outletnumber__c
      this.store_text = response.Title
      if (response.qualificationcertifica) {
        this.ckbox_cfe = response.qualificationcertifica.split(',')
      }
    },

    // 选择器确认方法
    onConfirm_Identity (e) {
      this.Identity = e
      this.showPicker_Identity = false
    },
    onConfirm_duty (e) {
      this.show_duty = e
      this.showPicker_duty = false
    },
    onConfirm_time (e) {
      this.show_time = e
      this.showPicker_time = false
    },
    onConfirm_record (e) {
      this.show_record = e
      this.showPicker_record = false
    },
    onConfirm_subject (e) {
      this.show_subject = e
      this.showPicker_subject = false
    },
    onConfirm_year (e) {
      this.show_year = e
      this.showPicker_year = false
    },
    onConfirm_addr (value) {
      this.pca_list = value
      this.pca_text = value.join(',')
      this.show_city = false
      this.store_text = ''
      this.store_object = {}
      this.account_text = ''
    },
    onConfirm_account (value) {
      this.account_text = value.Account_Short_Name__c
      this.show_account = false
      this.store_text = ''
      this.store_object = {}
    },
    onConfirm_store (value) {
      this.store_text = value.Title
      this.store_object = value
      this.show_store = false
    },

    // 弹出选择器
    showPopup () {
      this.show_city = true
    },
    async showlss () {
      if (!this.pca_text) {
        this.$toast('请先选择省市区')
        return
      }
      await this.WeChatMember_GetStoreAccount_fn()
      this.show_account = true
    },
    async showmd () {
      if (!this.pca_text || !this.account_text) {
        this.$toast('请先选择省市区和零售商')
        return
      }
      await this.WeChatMember_GetStore_fn()
      this.show_store = true
    },

    // API调用
    async WeChatMember_GetStoreArea_fn () {
      const { data } = await WeChatMember_GetStoreArea()
      this.area_list = data.response
    },
    async WeChatMember_GetStoreAccount_fn () {
      const { data } = await WeChatMember_GetStoreAccount({
        Province: this.pca_list[0],
        City: this.pca_list[1],
        Area: this.pca_list[2]
      })
      this.account_list = data.response
    },
    async WeChatMember_GetStore_fn () {
      const { data } = await WeChatMember_GetStore({
        Province: this.pca_list[0],
        City: this.pca_list[1],
        Area: this.pca_list[2],
        Account_Short_Name__c: this.account_text
      })
      this.store_list = data.response
    },

    // 返回登录页
    goBack () {
      this.$router.replace({ path: '/' })
    },

    // 发送验证码
    sendCode_time () {
      let num = 60
      const timer = setInterval(() => {
        num--
        if (num === 0) {
          this.codeMsg = '重新获取'
          this.SEND_CODE_IF = false
          clearInterval(timer)
          return
        }
        this.codeMsg = num + 's'
      }, 1000)
    },
    async sendCode () {
      if (this.SEND_CODE_IF) return
      if (!this.userTel[1].validator(this.userphone)) {
        this.$toast('请检查手机号是否填写正确')
        return
      }
      this.SEND_CODE_IF = true
      const { data } = await Member_send_message({ Phone: this.userphone })
      if (data.status === 200) {
        this.sendCode_time()
      } else {
        this.$toast(data.msg)
        this.SEND_CODE_IF = false
      }
    },

    // 提交表单
    async onSubmit (values) {
      if (this.submitting) return

      // 表单验证
      if (this.Identity === '零售商' && (!this.pca_text || !this.store_text || !this.account_text)) {
        this.$toast('请完善门店信息')
        return
      }
      if (this.isEnterpriseNameRequired && !this.EnterpriseName) {
        this.$toast('请完善医院名称/企业名称/学校名称')
        return
      }
      if (!this.username) {
        this.$toast('请填写姓名')
        return
      }
      if (!this.userTel[1].validator(this.userphone)) {
        this.$toast('请检查手机号是否填写正确')
        return
      }
      if (this.password.length < 6 && !this.EDIT_IF) {
        this.$toast('请填写验证码')
        return
      }
      if (!this.show_duty) {
        this.$toast('请填写工作职责')
        return
      }
      if (!this.show_record) {
        this.$toast('请选择学历')
        return
      }
      if (!this.show_subject) {
        this.$toast('请选择专业')
        return
      }
      if (!this.show_year) {
        this.$toast('请选择毕业年份')
        return
      }
      if (!this.ins_gra) {
        this.$toast('请填写毕业院校')
        return
      }

      this.submitting = true
      try {
        // 构建提交数据
        // 手动设置 picker 选择器的值（readonly field 不会自动收集到 values 中）
        values.Identity = this.Identity
        values.position_pro = this.show_duty
        values.vision_exp = this.show_time
        values.edu_qual = this.show_record
        values.Major = this.show_subject
        values.graduation_year = this.show_year
        values.qualificationcertifica = this.ckbox_cfe.join(',')
        values.Province = this.pca_list[0]
        values.City = this.pca_list[1]
        values.Area = this.pca_list[2]
        values.Account_Short_Name__c = this.account_text
        values.Outletnumber__c = this.store_object.Outletnumber__c
        values.Title = this.store_text
        values.EnterpriseName = this.EnterpriseName
        values.registration_source = this.$route.query.registration_source || localStorage.getItem('registration_source')
        // 验证码转换为整数
        if (values.CheckCode) {
          values.CheckCode = parseInt(values.CheckCode, 10)
        }

        let result
        if (this.EDIT_IF) {
          const mergedData = Object.assign(this.QueryMember, values)
          result = await WeChatMember_UptMember(mergedData)
        } else {
          result = await Member_AddMember(values)
        }

        if (result.data.status === 200) {
          this.$dialog({
            message: result.data.msg,
            confirmButtonColor: '#00b7ee'
          }).then(() => {
            this.$router.push({ path: this.EDIT_IF ? '/home' : '/' })
          })
        } else {
          this.$dialog({
            message: result.data.msg,
            confirmButtonColor: '#00b7ee'
          })
        }
      } finally {
        this.submitting = false
      }
    }
  }
}
</script>

<style scoped>
.register-page {
  min-height: 100vh;
  min-height: calc(100vh - env(safe-area-inset-top) - env(safe-area-inset-bottom));
  min-height: -webkit-fill-available;
  background: #f5f7fa;
  padding-bottom: 40px;
  padding-top: env(safe-area-inset-top);
}

/* 顶部区域 */
.page-header {
  background: linear-gradient(135deg, #d51900 0%, #b01500 50%, #8a1000 100%);
  padding: 50px 20px 70px;
  position: relative;
  overflow: hidden;
}

.header-back {
  position: absolute;
  top: 16px;
  left: 16px;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  z-index: 10;
  cursor: pointer;
}

.header-back:active {
  opacity: 0.7;
}

.header-back svg {
  width: 24px;
  height: 24px;
}

.header-decoration {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.deco-circle {
  position: absolute;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.08);
}

.deco-circle-1 {
  width: 150px;
  height: 150px;
  top: -50px;
  right: -30px;
}

.deco-circle-2 {
  width: 100px;
  height: 100px;
  bottom: 0;
  left: -30px;
}

.header-content {
  position: relative;
  z-index: 1;
  text-align: center;
}

.page-title {
  font-size: 28px;
  font-weight: 800;
  color: #ffffff;
  margin: 0 0 8px;
  letter-spacing: 2px;
  text-shadow: 0 4px 15px rgba(0, 0, 0, 0.15);
}

.page-subtitle {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.9);
  margin: 0;
}

/* 表单卡片 */
.form-card {
  background: #ffffff;
  border-radius: 24px 24px 0 0;
  margin-top: -30px;
  padding: 24px 16px;
  position: relative;
  z-index: 10;
  min-height: calc(100vh - 150px);
}

/* 表单区块 */
.form-section {
  margin-bottom: 24px;
}

.section-title {
  display: flex;
  align-items: center;
  font-size: 17px;
  font-weight: 800;
  color: #1a2a3a;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 3px solid #d51900;
}

.title-icon {
  margin-right: 8px;
  font-size: 18px;
}

/* 输入框组 */
.field-group {
  background: #f8f8f8;
  border-radius: 16px;
  padding: 8px;
}

.field-group .van-field {
  background: #ffffff !important;
  border-radius: 12px !important;
  margin-bottom: 8px !important;
  border: 1px solid #eee !important;
  min-height: 44px !important;
}

.field-group .van-field ::v-deep .van-field__body {
  min-height: 24px;
}

.field-group .van-field:last-child {
  margin-bottom: 0 !important;
}

/* 复选框样式 */
.checkbox-field {
  background: #ffffff;
  border-radius: 12px;
  padding: 16px;
  border: 1px solid #eee;
}

.checkbox-label {
  display: block;
  font-size: 14px;
  color: #666;
  margin-bottom: 12px;
}

.checkbox-group {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.checkbox-group .van-checkbox {
  margin: 0;
  padding: 8px 12px;
  background: #f8f8f8;
  border-radius: 8px;
  font-size: 13px;
}

/* 验证码按钮 */
.code-btn {
  background: linear-gradient(135deg, #d51900 0%, #ff3b2f 100%) !important;
  border: none !important;
  color: #ffffff !important;
  font-weight: 600 !important;
  padding: 0 10px !important;
  height: 22px !important;
  min-height: 22px !important;
  border-radius: 11px !important;
  font-size: 11px !important;
  line-height: 20px !important;
  margin: 0 !important;
  vertical-align: middle !important;
}

.code-btn-disabled {
  background: #e8e8e8 !important;
  color: #999 !important;
}

/* 确保验证码输入框高度与其他一致 */
.field-group .van-field ::v-deep .van-field__button {
  padding-left: 8px;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

/* 提交按钮 */
.submit-section {
  padding: 20px 0;
}

.submit-btn {
  height: 50px !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  letter-spacing: 2px;
  background: linear-gradient(135deg, #d51900 0%, #ff3b2f 100%) !important;
  border: none !important;
  box-shadow: 0 6px 20px rgba(213, 25, 0, 0.3) !important;
}

.submit-btn:active {
  transform: scale(0.98);
}

/* iOS safe area 兼容 */
@supports (padding-top: constant(safe-area-inset-top)) {
  .register-page {
    padding-top: constant(safe-area-inset-top);
  }
}

/* 移动端适配 */
@media screen and (max-width: 375px) {
  .page-header {
    padding: 40px 16px 60px;
  }
  
  .page-title {
    font-size: 24px;
  }
  
  .form-card {
    padding: 20px 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/register.vue